import { Injectable } from '@angular/core';
import { IDomEventSub } from '../../models/IDomEventSub';

@Injectable({ providedIn: 'root' })
export class DomSubsService {
    private rendererSubs: IDomEventSub[] = [];

    public addSub(newSub: IDomEventSub) {
        // this.rendererSubs.push(newSub);
    }

    public removeAllSubs() {
        this.rendererSubs.forEach((s) => s.listenerFn());
        this.rendererSubs = [];
    }
}
